import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { CenterDataForm } from '../../../app/models/Center';
import CenterForm from './forms/CenterForm';

type SelectOpt = { id: number | string; name: string };
interface Props {
  fetching?: boolean;
  action: () => void;
  cancel: () => void;
  center: CenterDataForm;
  setCenter: (data: CenterDataForm) => void;
  errorFields?: any;
  societies?: SelectOpt[];     
}

const CenterFormContainer = ({
  fetching,
  action,
  cancel,
  center,
  setCenter,
  errorFields = null,
  societies = [], 
}: Props) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <CenterForm
            centerDataForm={center}
            setCenterDataForm={setCenter}
            errorFields={errorFields}
            societiesOpts={societies}
          />
        </div>
      </div>
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={action} locked={fetching} />
        </div>
      </div>
    </>
  );
};

export default CenterFormContainer;
